module.exports = __webpack_public_path__ + "img/logoCSS.1264341d.svg";